import React from "react";

function EscapeMbtiBlock() {
  return (
    <section className="result-section result-section-subtle">
      <h2 className="result-section-title">
        진짜 너를 찾으려면 MBTI를 벗어나라, 제발
      </h2>
      <p className="result-body-text">
        <br /> MMBBTTII는 E / I / S / N / T / F / P / J 여덟 가지 성향을 각각
        그대로 보여주려 합니다.
      </p>
      <p className="result-body-text">
        E냐 I냐, 둘 중 하나를 고르는 게 아니라 &quot;나는 이 성향을 얼마나 자주,
        얼마나 세게 쓰고 있지?&quot;를 숫자로 보는 게 이 서비스의 핵심이에요.
      </p>
      <p className="result-body-text">
        그러니까 &quot;나 ENFP 맞나? INFJ인가?&quot; 같은 고민은 잠깐 내려놓고,
        이 여덟 개 숫자를 보면서 &quot;진짜 당신을 바라보세요.
      </p>
    </section>
  );
}

export default EscapeMbtiBlock;
